@if(policyStore?.policyData?.policy.quoteStatus === 'ISS' || (policyVerified &&
policyStore?.policyData?.policy.quoteStatus !== 'ISS')){
<apt-template-nested-state state="success" title="Payment Success" style="margin-top: -20px">
  <ng-container message>
    <div fxFlexOffset="30" fxFlex="40" style="text-align: justify">
      <p style="font-size: 0.9em">
        Your payment has been successfully processed. We will email your policy and receipt of payment shortly. The
        email will contain important information on how to make changes to your policy and how to file claims.
      </p>
      <p
        *ngIf="cyberOfferEnabled && !isCyberFlow"
        style="
          font-family: Open Sans Semibold, Open Sans, sans-serif;
          font-weight: 600;
          color: #333f48;
          text-align: center;
          line-height: normal;
          font-size: 16px;
          margin-bottom: 16px;
        "
      >
        Want Cyber insurance too? It's just few simple questions away!
      </p>
      <div *ngIf="!isCyberFlow" style="display: flex; justify-content: center; gap: 12px; margin-top: 20px">
        <apt-button *ngIf="cyberOfferEnabled" class="cyber-cta" [primary]="true" (click)="navigateToCyber()">
          Begin Cyber Application
        </apt-button>
        <apt-button *ngIf="isProgressiveFlow" (click)="goBackToBQX()" secondary="default">Back to BQX</apt-button>
      </div>
    </div>
  </ng-container>

  <apt-button-footer footer>
    <ng-container buttonFooterRight>
      @if(policyStore?.policyData?.policy.quoteStatus === 'ISS'){
      <apt-button [primary]="true" (click)="downloadPolicy()" [loading]="downloading" [loadingExpectedTime]="9000">{{
        downloading ? 'Downloading Policy' : 'Download Policy'
      }}</apt-button>
      }
    </ng-container>
  </apt-button-footer>
</apt-template-nested-state>
}
